/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Row } from 'reactstrap';
import { forEach, remove, map } from 'lodash';
import { connect } from 'react-redux';
import { saveAs } from 'file-saver';
import PropTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import RUTJS from 'rutjs';

import { setRUTFormat, isUserAllowed, isOptionAllowed } from '../../../shared/utils';
import BasicNotification from '../../../shared/components/Notifications/BasicNotification';
import DModal from '../../../shared/components/Modal/Modal';
import EModal from '../../../shared/components/Modal/ModalE';
import AssignActivityModal from './AssignActivityModal';
import ModalContactoEdit from '../../Contactos/components/ModalContactoEdit';
import CloseCaseModal from '../../../shared/components/Modal/CloseCaseModal';
import MailsContents from '../../CotizacionesDetalle/components/MailsContents';
import {
  getCasesIdMe,
  getCasesId,
  deleteCase,
  getAllTypesCases,
  getAllSubTypesCases,
  updateCase,
  updateCaseMe,
  createCase,
  createMyCase,
  getSignedDocument,
  getDocumentS3,
  postDocumentS3,
  getAllS3Documents,
  resetAllS3Documents,
  getRequestGrounds,
  getRequestClassifications
} from '../../../redux/actions/casesActions';
import { ADMIN_CASE_ROLE_FILTER, DEC_CASE_ROLE_FILTER, ROLES, refinancingAllowedList } from '../../../helper/constants';
import { getContactByRut, getContractByRut, resetState, } from '../../../redux/actions/contactosActions';
import { getUsers, getMe, makeCall } from '../../../redux/actions/userActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import { getOrigins } from '../../../redux/actions/resourcesActions';
import { originTraducer } from '../../../helper/functions';
import { getScoreList } from '../../../redux/actions/scoreAction';
import ModalFindClient from '../../Casos/components/AssignCaseModal';
import MakeCall from '../../../shared/components/make-call';
import ScoreModal from '../score/score-modal';
import CaseDetailFormCard from './case-components/CaseDetailFormCard';
import CaseActivitiesCard from './case-components/CaseActivitiesCard';
import CaseSummaryCard from './case-components/CaseSummaryCard';
import CaseManagementHistoryCard from './case-components/CaseManagementHistoryCard';
import CaseCustomerDocumentsTabs from './case-components/CaseCustomerDocumentsTabs';

const isRUTValid = (rut) => {
  if (!rut) return true;
  return (new RUTJS(rut)).isValid;
}

const widthEmail = [{ value: true, label: 'Si' }, { value: false, label: 'No' }];
const cmfOptions = [{ value: true, label: 'Si' }, { value: false, label: 'No' }];

const initialScoreValue = { value: '', label: 'Seleccione' };

class CasoDetalle extends Component {
  constructor() {
    super();
    this.state = {
      isOpenModalD: false,
      isOpenModalE: false,
      isOpenModalAssignActivity: false,
      isOpenModalCloseCase: false,
      isOpenModalContactEdit: false,
      isOpenModalAassignClient: false,
      isOpenScoreModal: false,
      cancelAssignclient: false,
      hideFind: true,
      disabledIt: true,
      hideNewContact: false,
      isOpenModalMessageMail: false,
      messages: undefined,
      NewMessage: {
        editor: null,
        attachments: [],
      },
      idDetail: null,
      new: false,
      _id: null,
      origin: { value: null, label: null },
      status: { value: 'opened', label: 'Abierto' },
      type: null,
      subtype: null,
      description: undefined,
      code: '',
      assign: '',
      client: '',
      activities: [],
      score: initialScoreValue,
      executive: null,
      createdAt: '',
      commitmentDate: '',
      names: '',
      paternalSurname: '',
      sourceMail: '',
      rut: '',
      email: '',
      isRedec: null,
      requestGrounds: null,
      requestGroundsRaw: null,
      requestClassifications: null,
      requestClassificationsRaw: null,
      emailArrayToMailsContents: [],
      users: [],
      editField: true,
      showButton: false,
      updateLocal: false,
      activity: {
        description: null,
        executive: null,
      },
      callPhone: null,
      isMakeCallOpen: false,
      signedDoc: undefined,
      sendEmail: { value: true, label: 'Si' },
      documentS3: [],
      documenttoS3: [],
      scoreOptions: [],
      scoreCurrent: initialScoreValue,
    };
  }

  componentDidMount() {
    const token = localStorage.getItem('accessToken');
    this.props.setTitle('Detalle del caso');
    this.props.getMe();
    this.props.getOrigins();
    this.props.getRequestGrounds();
    this.props.getRequestClassifications();
    this.props.getScoreList((res) => {
      if (res?.length) {
        this.setState({ scoreOptions: map(res, (e) => ({ value: e.label, label: e.label })) });
      }
    });
    const { id, rut } = this.props.match.params;
    if (id) {
      const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
      const isDecExec = isUserAllowed('dec-executive') || isUserAllowed('dec-executive-port');
      if (isAdmin) {
        this.props.getCasesId(id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
        this.props.getUsers({ all: true, roles: ADMIN_CASE_ROLE_FILTER }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      } else {
        this.props.getCasesIdMe(id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
      }
      if (isDecExec) {
        this.props.getUsers({ all: true, roles: DEC_CASE_ROLE_FILTER }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      }
      this.props.getSignedDocument(id, (res) => {
        if (res) {
          this.setState({ signedDoc: res });
        }
      });
    }

    if (rut) {
      const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
      const isDecExec = isUserAllowed('dec-executive') || isUserAllowed('dec-executive-port');
      if (isAdmin) {
        this.props.getUsers({ all: true, roles: ADMIN_CASE_ROLE_FILTER }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      }
      if (isDecExec) {
        this.props.getUsers({ all: true, roles: DEC_CASE_ROLE_FILTER }, (body) => {
          this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
        });
      }
      this.props.getContactByRut(rut, (body) => {
        this.setState({
          new: true,
          client: body._id,
          createdAt: new Date(),
          names: body.companyName || body.names || '',
          paternalSurname: body.paternalSurname || '',
          rut: body.rut,
          email: body.emails.length > 0 ? body.emails[0].email : '',
          editField: false
        });
      });
      this.props.getContractByRut(rut);
    }

    this.props.getAllTypesCases({ all: true });
    if (token) {
      const { user } = jwtDecode(token);
      this.setState({ _idWhenAdmin: user._id });
    }
  }

  componentDidUpdate() {
    const {
      rut,
      updateLocal,
      isOpenModalAassignClient,
      cancelAssignclient,
      requestGrounds,
      requestGroundsRaw,
      requestClassifications,
      requestClassificationsRaw,
    } = this.state;
    const { getContactByRut, getContractByRut } = this.props;
    if (rut && (rut !== '') && !updateLocal && isOpenModalAassignClient === false && cancelAssignclient === false) {
      getContactByRut(rut, () => { });
      getContractByRut(rut);
      this.setState({ updateLocal: true });
    }

    if (requestGroundsRaw && !requestGrounds && this.props.requestGrounds.length > 0) {
      const selectedRequestGround = this.findRequestGroundOption(requestGroundsRaw);
      if (selectedRequestGround) {
        this.setState({ requestGrounds: selectedRequestGround });
      }
    }

    if (requestClassificationsRaw && !requestClassifications && this.props.requestClassifications.length > 0) {
      const selectedRequestClassification = this.findRequestClassificationOption(requestClassificationsRaw);
      if (selectedRequestClassification) {
        this.setState({ requestClassifications: selectedRequestClassification });
      }
    }
  }

  componentWillUnmount() {
    const { resetState, resetAllS3Documents } = this.props;
    resetAllS3Documents();
    resetState();
  }

  getEmails = (client) => {
    if (client?.emails?.length) {
      return map(client.emails, e => ({ value: e.email, label: e.email }));
    }
    return [];
  };

  getClientEmail = (clientEmail) => {
    if (clientEmail) {
      return [{ value: clientEmail, label: clientEmail }];
    }
    return [];
  };

  emailArrayToMailsContents = (value) => {
    const { client, clientEmail } = value;
    return this.getEmails(client).concat(this.getClientEmail(clientEmail));
  };

  getRequestGroundOptionValue = (item) => item?._id || item?.id || item?.value || item?.code || item?.name || item?.label || item;

  getRequestGroundOptionLabel = (item) => item?.name || item?.label || item?.description || item?.reason || item?.value || item;

  getRequestGroundOptions = () => map(this.props.requestGrounds || [], (item) => ({
    value: this.getRequestGroundOptionValue(item),
    label: this.getRequestGroundOptionLabel(item),
  }));

  getRequestClassificationOptions = () => map(this.props.requestClassifications || [], (item) => ({
    value: this.getRequestGroundOptionValue(item),
    label: this.getRequestGroundOptionLabel(item),
  }));

  findRequestGroundOption = (value) => {
    if (!value) return null;

    const optionValue = this.getRequestGroundOptionValue(value);
    const optionLabel = this.getRequestGroundOptionLabel(value);
    const options = this.getRequestGroundOptions();

    return options.find((option) => (
      `${option.value}` === `${optionValue}` || option.label === optionLabel
    )) || (optionLabel ? { value: optionValue, label: optionLabel } : null);
  };

  findRequestClassificationOption = (value) => {
    if (!value) return null;

    const optionValue = this.getRequestGroundOptionValue(value);
    const optionLabel = this.getRequestGroundOptionLabel(value);
    const options = this.getRequestClassificationOptions();

    return options.find((option) => (
      `${option.value}` === `${optionValue}` || option.label === optionLabel
    )) || (optionLabel ? { value: optionValue, label: optionLabel } : null);
  };

  findCMFOption = (value) => {
    if (value === true) return cmfOptions[0];
    if (value === false) return cmfOptions[1];
    return null;
  };

  assignValueOnState = (value) => {
    const { id } = this.props.match.params;
    this.props.getAllSubTypesCases({ all: true, type: value.type._id });

    this.setState({
      idDetail: id,
      _id: id,
      flatForClient: !!value.client,
      type: { value: value.type._id, label: value.type.name },
      subtype: { value: value.subtype._id, label: value.subtype.name },
      status: this.findValue(value.status),
      messages: value?.messages,
      branchOffice: value?.branchOffice || 'Casa Matriz',
      origin: { label: originTraducer(value.origin), value: originTraducer(value.origin) },
      sourceMail: value.sourceMail || '',
      description: value.description,
      createdAt: value.createdAt,
      closedDate: value.closedDate,
      commitmentDate: value.commitmentDate,
      isRedec: this.findCMFOption(value?.isRedec),
      requestGround: this.findRequestGroundOption(value?.requestGround),
      requestGroundsRaw: value?.requestGround || null,
      requestClassification: this.findRequestClassificationOption(value?.requestClassification),
      requestClassificationsRaw: value?.requestClassification || null,
      names: value?.client?.names || value?.client?.companyName || '',
      paternalSurname: value?.client?.paternalSurname || '',
      rut: value?.client?.rut || '',
      email: value?.client?.emails?.length && (value.client.emails[0].email || ''),
      emailArrayToMailsContents: this.emailArrayToMailsContents(value),
      clientEmail: value?.clientEmail || undefined,
      rentClient: value?.client?.rent || '',
      phone: value?.client?.phones[0] || '',
      code: value.code,
      activities: value.activities,
      score: value?.score ? { value: value?.score || '', label: value?.score || '' } : initialScoreValue,
      scoreCurrent: value?.score ? { value: value?.score || '', label: value?.score || '' } : initialScoreValue,
      executive: { value: value?.executive?._id || '', label: `${value?.executive?.firstName || ''} ${value?.executive?.lastName || ''}` },
      client: value?.client?._id || '',
      documentS3: value?.documentsS3 || [],
      isRef: value?.isRef || false
    });
    this.props.getAllS3Documents(id);
  }

  cancelEdit = () => {
    const { id } = this.props.match.params;
    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');

    if (isAdmin) {
      this.props.getCasesId(id, (caseInfo) => {
        this.assignValueOnState(caseInfo);
      });
    } else {
      this.props.getCasesIdMe(id, (caseInfo) => {
        this.assignValueOnState(caseInfo);
      });
    }

    this.setState({ editField: true, showButton: false, documenttoS3: [] });
  }

  startEdit = () => {
    this.setState({ editField: false, showButton: true });
  }

  findValue = (value) => {
    const valueLabelMap = {
      'pending': 'Pendiente',
      'opened': 'Abierto',
      'closed': 'Cerrado',
      're-opened': 'Reabierto',
      'phone': 'Teléfono',
      'email': 'Correo',
      'web': 'Web',
      'referred': 'Referido',
      'face': 'Presencial'
    };

    if (valueLabelMap.hasOwnProperty(value)) {
      return { value: value, label: valueLabelMap[value] };
    }
    return null;
  }

  onChangeActivity = key => e => {
    let value = e.target.value;
    this.setState(prevState => {
      return { activity: { ...prevState.activity, [key]: value } };
    });
  };

  onClickModalAssignClient = () => {
    this.setState({
      isOpenModalAassignClient: true,
      cancelAssignclient: true,
      hideFind: false,
      disabledIt: false,
      hideNewContact: true,
      rut: '',
    });
  }

  onChangeInput = key => (e) => {
    if (
      (key === 'origin')
      || (key === 'subtype')
      || (key === 'appointment')
      || (key === 'executive')
      || (key === 'status')
      || (key === 'sendEmail')
      || (key === 'score')
      || (key === 'isRedec')
      || (key === 'requestGrounds')
      || (key === 'requestClassifications')
      || (key === 'commitmentDate')
    ) {
      this.setState({ [key]: e });
    } else if ((key === 'type')) {
      this.setState({ [key]: e, subtype: null });
      if (e.label.toLowerCase() === 'consulta') {
        this.setState({ score: initialScoreValue });
      }
      if (e) {
        this.props.getAllSubTypesCases({ all: true, type: e.value });
      }
    } else if (key === 'rut') {
      this.setState({ [key]: setRUTFormat(e.target.value) });
    } else {
      this.setState({ [key]: e.target.value });
    }
  }

  onSubmitNewCase = (e) => {
    if (e) e.preventDefault();

    const {
      _id,
      origin,
      status,
      type,
      subtype,
      description,
      assign,
      client,
      executive,
      code
    } = this.state;

    if (origin.value === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un origen.',
      });

      return;
    }

    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');

    if (isAdmin) {
      if (executive === null) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'Debe seleccionar un ejecutivo.',
        });
        return;
      }
    }

    if (subtype === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar una tipificación.',
      });
      return;
    }

    if (type === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un tipo.',
      });
      return;
    }

    if (description === undefined) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar una descripcion.',
      });
      return;
    }

    if (origin === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un origen.',
      });

      return;
    }

    if (status === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe seleccionar un estado.',
      });
    }

    this.sendData({
      _id,
      origin: origin.value,
      status: status.value,
      type: type.value,
      subtype: subtype.value,
      description: description.trim(),
      assign,
      client,
      sendEmail: this.state.sendEmail.value,
      executive: executive.value,
      score: this.state.score?.value || '',
      isRedec: this.state.isRedec?.value,
      requestGround: this.state.requestGrounds?.value || null,
      requestClassification: this.state.requestClassifications?.value || null,
      commitmentDate: this.state.commitmentDate ? moment(this.state.commitmentDate).toISOString() : null,
      code
    });
  }

  onSubmitNewActivity = (e) => {
    if (e) e.preventDefault();

    const { _id } = this.state;

    if (_id === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Se debe crear el caso antes de ingresar actividades.',
      });

      return;
    }

    const activityState = {
      description: this.state.activity?.description?.trim() || '',
      executive: this.state.executive.value,
    };

    if (activityState.description === null) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar una descripcion para la actividad.',
      });
    } else {
      const data = {
        action: 'addActivity',
        activity: activityState,
      };

      const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port');
      if (isAdmin) {
        data.activity.executive = this.state._idWhenAdmin;
        this.props.updateCase(_id, data, () => {
          this.setState({ isOpenModalAssignActivity: false });
          this.props.getCasesId(_id, (caseInfo) => {
            this.setState({
              activities: caseInfo.activities,
              executive: { value: (caseInfo.executive) ? caseInfo.executive._id : '', label: caseInfo.executive ? `${caseInfo.executive.firstName} ${caseInfo.executive.lastName}` : '' },
              client: (caseInfo.client) ? caseInfo.client.rut : '',
            });
          });
          this.props.getUsers({ all: true }, (body) => {
            this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
          });
        });
      } else {
        this.props.updateCaseMe(_id, data, () => {
          this.setState({ isOpenModalAssignActivity: false });
          this.props.getCasesIdMe(_id, (caseInfo) => {
            this.setState({
              activities: caseInfo.activities,
              executive: { value: (caseInfo.executive) ? caseInfo.executive._id : '', label: caseInfo.executive ? `${caseInfo.executive.firstName} ${caseInfo.executive.lastName}` : '' },
              client: (caseInfo.client) ? caseInfo.client.rut : '',
            });
          });
        });
      }
    }
  }

  sendData = (data) => {
    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
    const isDecExec = isUserAllowed('dec-executive') || isUserAllowed('dec-executive-port');

    if (!data._id) {
      delete data._id;
      if (isAdmin) {
        this.props.createCase(data, (body) => {
          this.handleUploadS3(body);
        });
      } else {
        this.props.createMyCase(data, (body) => {
          this.handleUploadS3(body);
        });
      }
    } else if (isAdmin) {
      this.props.updateCase(data._id, data, () => {
        this.props.getCasesId(data._id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
        this.handleUploadS3(data);
      });
    } else if (isDecExec && data.executive !== this.state._idWhenAdmin) {
      this.props.updateCase(data._id, data, () => {
        this.props.getCasesId(data._id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
          this.handleUploadS3(data);
        });
      });
    } else {
      this.props.updateCaseMe(data._id, data, () => {
        this.props.getCasesIdMe(data._id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
          this.handleUploadS3(data);
        });
      });
    }
    this.setState({ editField: true, showButton: false });
  }

  handleUploadS3 = (data) => {
    this.setState({ _id: data._id });
    if (this.state.documenttoS3.length) {
      let promise = Promise.resolve();
      for (const file of this.state.documenttoS3) {
        promise = promise.then(() => {
          const formData = new FormData();
          formData.append('file', file);
          this.props.postDocumentS3(data.code, formData);
        });
      }
      promise.then(() => {
        this.props.getAllS3Documents(this.state._id);
        this.setState({ documenttoS3: [] });
        this.props.history.push(`/casos/${data._id}`);
      });
    } else {
      this.props.history.push(`/casos/${data._id}`);
    }
  }

  onClickModalNewMailsReplays = () => {
    const NewMessage = {
      body: null,
      editor: null,
      attachments: [],
    };
    this.setState({ isOpenModalMessageMail: true, NewMessage });
  }

  toggleModalNewMessage = () => {
    this.setState({ isOpenModalMessageMail: false });
  };

  onChangeMessage = key => e => {
    let event = e;
    let files = event?.target?.files || [];
    let value = event?.target?.value || '';
    this.setState(prevState => {
      const NewMessage = { ...prevState.NewMessage };
      if (key === 'editor' || key === 'to' || key === 'cc') {
        NewMessage[key] = event;
      } else if (key === 'attachments' && files?.length) {
        forEach(files || [], (file) => {
          NewMessage[key].push(file);
        });
      } else {
        NewMessage[key] = value;
      }
      return { NewMessage };
    });
  };

  onSubmitNewMailsReplays = (e) => {
    if (e) {
      e.preventDefault();
    }
    let message;
    if (this.mailRef) {
      message = this.mailRef.getTextHtml();
    }
    const { _id, NewMessage } = this.state;

    if (!_id) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Se debe crear la cotización antes de responder correos.',
      });
      return;
    }
    if (!message) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar mensaje para responder el correo.',
      });
      return;
    }

    if (!NewMessage.to) {
      BasicNotification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar el correo destinatario.',
      });
      return;
    }

    const data = {
      action: 'addMessage',
      to: NewMessage.to.value,
      cc: NewMessage.cc,
      body: message,
    };


    if (NewMessage.attachments) {
      let totalSize = 0;
      map(NewMessage.attachments, (file) => {
        totalSize += file.size;
      });
      if (totalSize > 5000000) {
        BasicNotification.show({
          color: 'danger',
          title: 'Atención',
          message: 'Los archivos adjuntos no pueden superar los 5 MB',
        });
        return;
      }
      data.attachments = NewMessage.attachments;
    }

    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
    const isDecExec = isUserAllowed('dec-executive') || isUserAllowed('dec-executive-port');
    if (isAdmin) {
      this.props.updateCase(_id, data, () => {
        this.setState({ isOpenModalMessageMail: false });
        this.props.getCasesId(_id, (casesInfo) => {
          this.setState({
            messages: casesInfo.messages ? casesInfo.messages : [],
            executive: casesInfo.executive ? { value: casesInfo.executive._id, label: `${casesInfo.executive.firstName} ${casesInfo.executive.lastName}` } : null,
            client: casesInfo.client ? casesInfo.client.rut : '',
          });
        });
      });
    } else {
      this.props.updateCaseMe(_id, data, () => {
        this.setState({ isOpenModalMessageMail: false });
        this.props.getCasesIdMe(_id, (casesInfo) => {
          this.setState({
            messages: casesInfo.messages ? casesInfo.messages : [],
            executive: casesInfo.executive ? { value: casesInfo.executive._id, label: `${casesInfo.executive.firstName} ${casesInfo.executive.lastName}` } : null,
            client: casesInfo.client ? casesInfo.client.rut : '',
          });
        });
      });
    }
    if (isAdmin || isDecExec) {
      this.props.getUsers({ all: true }, (body) => {
        this.setState({ users: map(body, user => ({ value: user._id, label: `${user.firstName} ${user.lastName}` })) });
      });
    }
  }

  onClickDeleteCase = caseSelected => () => {
    this.setState({ isOpenModalD: true, caseSelected: caseSelected || this.props.match.params.id });
  }

  onClickEditCase = caseSelected => () => {
    this.setState({ isOpenModalE: true, caseSelected });
  }

  onDelete = () => {
    const { caseSelected } = this.state;
    this.props.deleteCase(caseSelected, () => {
      this.setState({ isOpenModalD: false });
      this.props.history.push('/casos');
    });
  }

  onCloseCase = () => {
    const { caseSelected } = this.state;
    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');

    const data = {
      action: 'close',
    };

    if (isAdmin) {
      this.props.updateCase(caseSelected, data, () => {
        this.props.getCasesId(caseSelected, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
      });
    } else {
      this.props.updateCaseMe(caseSelected, data, () => {
        this.props.getCasesIdMe(caseSelected, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
      });
    }
  }

  toggleDeleteContacto = isOk => () => {
    if (isOk) {
      this.onDelete();
    } else {
      this.setState({ isOpenModalD: false });
    }
  }

  toggleEditContacto = isOk => () => {
    if (isOk) {
      this.onSubmitNewCase();
    } else {
      this.setState({ isOpenModalE: false });
    }
  }

  toggleCloseCase = isOk => () => {
    if (isOk) {
      this.setState({ isOpenModalCloseCase: false });
      this.onCloseCase();
    } else {
      this.setState({ isOpenModalCloseCase: false });
    }
  }

  toggleModalAssignActivity = () => {
    this.setState({ isOpenModalAssignActivity: false });
  };

  onClickModalAssignActivity = () => {
    const activity = {
      description: null,
      executive: null,
    };
    this.setState({ isOpenModalAssignActivity: true, activity });
  }

  handleSavePDF = async () => {
    const { id } = this.props.match.params;
    // await this.props.getSignedDocument('6058f97818b3fd4039754b12', (res) => {
    if (this.state.signedDoc) {
      this.downloadPDF(this.state.signedDoc, 'autofin_portabilidad.pdf');
    } else {
      await this.props.getSignedDocument(id, (res) => {
        this.downloadPDF(res, 'autofin_portabilidad.pdf');
      });
    }
  }

  handleSaveDocS3 = async (doc) => {
    await this.props.getDocumentS3(doc.name, (res) => {
      this.downloadPDF(res?.file64, doc.name);
    })
  }

  downloadPDF = (base64file, name) => {
    const byteArray = new Uint8Array(atob(base64file).split('').map(char => char.codePointAt(0)));
    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(pdfBlob, name);
  }

  toggleModalAC = () => {
    this.setState({ isOpenModalAassignClient: false });
  };

  onNewContact = () => {
    const { clientEmail } = this.state;
    this.props.history.push(`/contactos?fromDetailsCase=true&newContact=true&rut=${this.state.rut}&idCase=${this.state.idDetail}&clientEmail=${clientEmail}`);
  }

  onSubmitAssign = (e) => {
    e.preventDefault();
    this.setState({ disabledIt: true });

    const {
      rut,
    } = this.state;
    const { id } = this.props.match.params;


    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');

    this.props.getContactByRut(rut.replace(/[^K0-9\s]/gi, ''), (body) => {
      if (body) {
        BasicNotification.show({
          color: 'success',
          title: 'Atención',
          message: 'Contacto encontrado.',
        });
        const assignClient = {
          action: 'assignClient',
          payload: {
            client: body._id,
          },
        };
        if (isAdmin) {
          this.props.updateCase(id, assignClient, () => {
            this.props.getCasesId(id, (caseInfo) => {
              this.assignValueOnState(caseInfo);
            });
            this.setState({ isOpenModalAassignClient: false });
          });
        } else {
          this.props.updateCaseMe(id, assignClient, () => {
            this.props.getCasesIdMe(id, (caseInfo) => {
              this.assignValueOnState(caseInfo);
            });
            this.setState({ isOpenModalAassignClient: false });
          });
        }
        this.setState({ client: rut.replace(/[^K0-9\s]/gi, '') });
        this.props.history.push(`/casos/${id}`);
      } else {
        this.setState({
          hideFind: true,
          hideNewContact: false,
        });
      }
    });
  }

  removeAttachment = e => () => {
    let event = e;
    this.setState(prevState => {
      const NewMessage = { ...prevState.NewMessage };
      const aux = [];
      NewMessage.attachments.forEach((file, index) => {
        if (index !== event) aux.push(file);
      });
      NewMessage.attachments = aux;
      return { NewMessage };
    });
  };

  setMailRef = (element) => {
    this.mailRef = element;
  };

  onClickContactoEditar = () => {
    this.setState({ isOpenModalContactEdit: true });
  }

  toggleModalContactEdit = isOk => () => {
    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
    const { id } = this.props.match.params;
    if (isOk) {
      if (isAdmin) {
        this.props.getCasesId(id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
      } else {
        this.props.getCasesIdMe(id, (caseInfo) => {
          this.assignValueOnState(caseInfo);
        });
      }
      this.props.getContactByRut(this.state.rut, () => {
        this.setState({ isOpenModalContactEdit: false });
      });
    } else {
      this.setState({ isOpenModalContactEdit: false });
    }
  }

  closeMakeCall = number => () => {
    const { anexo, denwaPassword } = this.props.currentUser;
    if (number) {
      this.props.makeCall({
        phone: number,
        user: {
          anexo,
          denwaPassword
        }
      });
    }
    this.setState({ callPhone: null, isMakeCallOpen: false });
  }

  openMakeCall = (e) => {
    this.setState({ callPhone: e, isMakeCallOpen: true });
  }

  handleAttachFile = (e) => {
    let archives = e.target.files;
    this.setState(prevState => {
      let allFiles = [...prevState.documenttoS3];
      forEach(archives, (file) => {
        remove(allFiles, (a) => file.name === a.name);
        allFiles.push(file);
      });
      return { documenttoS3: allFiles.slice(-5) };
    });
  }

  handleRemoveAttached = (e) => {
    let file = e;
    this.setState(prevState => {
      let allFiles = [...prevState.documenttoS3];
      remove(allFiles, (e) => e.name === file);
      return { documenttoS3: allFiles };
    });
  }

  handleCleanAttached = () => {
    this.setState({ documenttoS3: [] });
  }

  toggleScoreModal = () => {
    this.setState({ isOpenScoreModal: false, score: this.state.scoreCurrent });
  };

  handleScore = () => {
    const { type, rut } = this.state;
    if (type?.label?.toLowerCase() === 'reclamos' || type?.label?.toLowerCase() === 'solicitudes') {
      if (isRUTValid(rut) && rut) {
        this.setState({ isOpenScoreModal: true });
      } else {
        BasicNotification.error('Debe asignar un cliente antes el cerrar caso');
      }
    } else {
      this.setState({ isOpenModalCloseCase: true });
    }
    this.setState((prevState) => ({ caseSelected: prevState.idDetail }))
  }

  handleSubmitScore = (e) => {
    e.preventDefault();

    const { caseSelected, score } = this.state;
    if (score?.value) {
      const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
      const closeData = { action: 'close' };
      if (isAdmin) {
        this.props.updateCase(caseSelected, { score: score.value }, (status) => {
          if (status === 204) {
            this.props.updateCase(caseSelected, closeData, () => {
              this.toggleScoreModal();
              this.props.getCasesId(caseSelected, (caseInfo) => {
                this.assignValueOnState(caseInfo);
              });
            });
          }
        });
      } else {
        this.props.updateCaseMe(caseSelected, { score: score.value }, (status) => {
          if (status === 204) {
            this.props.updateCaseMe(caseSelected, closeData, () => {
              this.props.getCasesIdMe(caseSelected, (caseInfo) => {
                this.assignValueOnState(caseInfo);
                this.toggleScoreModal();
              });
            });
          }
        });
      }
    } else {
      BasicNotification.error('Debe ingresar una Clasificación');
    }
  }

  render() {
    moment().locale('es');
    const { type, users, emailArrayToMailsContents, } = this.state;

    const { types, subtypes, disable, contact, contracts, loadingInfoCase, disableCloseCase, cargandoContract } = this.props;

    const { rut } = this.props.match.params;

    const today = moment(new Date());
    let edad = 0;
    contact && (
      edad = moment(today).year() - moment(contact.birthdate).year()
    );

    const typesOptions = map(types, typ => ({ value: typ._id, label: typ.name }));
    const subtypesOptions = map(subtypes, subtype => ({ value: subtype._id, label: subtype.name }));
    const isAdmin = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager');
    const canReassign = isUserAllowed('admin') || isUserAllowed('admin-port') || isUserAllowed('manager') || isUserAllowed('dec-executive') || isUserAllowed('dec-executive-port');

    const formPersonal = '';

    const createEmail = `https://mail.google.com/mail/?view=cm&fs=1&to=${this.state.email}&su=AUTOFIN%20Caso%20número%20${this.state.code}&body=${formPersonal}`;

    return (
      <div className="dashboard container">
        <ModalFindClient
          isOpen={this.state.isOpenModalAassignClient}
          toggle={this.toggleModalAC}
          onSubmitAssign={this.onSubmitAssign}
          onChangeInput={this.onChangeInput}
          title="Asignar cliente"
          value={this.state}
          isRUTValid={isRUTValid}
          onNewContact={this.onNewContact}
          hideFind={this.state.hideFind}
          disabledIt={this.state.disabledIt}
          hideNewContact={this.state.hideNewContact}
        />
        <DModal
          title="Atención"
          color="danger"
          message="¿Esta seguro que desea borrar este registro?"
          isOpen={this.state.isOpenModalD}
          toggle={this.toggleDeleteContacto}
        />
        <EModal
          title="Atención"
          color="primary"
          message="¿Esta seguro que desea editar este registro?"
          isOpen={this.state.isOpenModalE}
          toggle={this.toggleEditContacto}
        />
        <CloseCaseModal
          title="Advertencia"
          color="warning"
          message="¿Esta seguro que desea Cerrar este caso?"
          isOpen={this.state.isOpenModalCloseCase}
          toggle={this.toggleCloseCase}
        />
        <AssignActivityModal
          isOpen={this.state.isOpenModalAssignActivity}
          toggle={this.toggleModalAssignActivity}
          value={this.state.activity}
          cargando={this.props.disableCloseCase}
          onSubmitNewActivity={this.onSubmitNewActivity}
          onChangeActivity={this.onChangeActivity}
        />
        <ScoreModal
          isOpen={this.state.isOpenScoreModal}
          toggle={this.toggleScoreModal}
          score={this.state.score}
          scoreOptions={this.state.scoreOptions}
          initialScoreValue={initialScoreValue}
          loading={this.props.disableCloseCase}
          handleSubmitScore={this.handleSubmitScore}
          onChangeInput={this.onChangeInput}
        />
        <ModalContactoEdit
          isOpen={this.state.isOpenModalContactEdit}
          rutToFind={this.state.rut}
          toggle={this.toggleModalContactEdit}
        />
        <MakeCall
          phone={this.state.callPhone}
          toggle={this.closeMakeCall}
          visible={this.state.isMakeCallOpen}
        />
        <Row>
          <div className="col-md-7">
            <CaseDetailFormCard
              state={this.state}
              type={type}
              rut={rut}
              managements={this.props.caseManagements?.entry || []}
              isAdmin={isAdmin}
              isAuditor={isUserAllowed(ROLES.auditor)}
              disableCreate={this.props.disableCreate}
              onSubmitNewCase={this.onSubmitNewCase}
              onStartEdit={this.startEdit}
              onDeleteCase={this.onClickDeleteCase}
              onChangeInput={this.onChangeInput}
              typesOptions={typesOptions}
              subtypesOptions={subtypesOptions}
              disable={disable}
              originOptions={map(this.props.origins, (e) => ({ label: e.name, value: e.name }))}
              canReassign={canReassign}
              users={users}
              widthEmailOptions={widthEmail}
              cmfOptions={cmfOptions}
              requestGroundsOptions={this.getRequestGroundOptions()}
              requestGroundsLoading={this.props.requestGroundsLoading}
              requestClassificationsOptions={this.getRequestClassificationOptions()}
              requestClassificationsLoading={this.props.requestClassificationsLoading}
              initialScoreValue={initialScoreValue}
              onAttachFile={this.handleAttachFile}
              onRemoveAttached={this.handleRemoveAttached}
              onCleanAttached={this.handleCleanAttached}
              onCancelEdit={this.cancelEdit}
              onClickAssignClient={this.onClickModalAssignClient}
              onGoBack={this.props.history.goBack}
              onChangeCommitmentDate={this.onChangeInput('commitmentDate')}
            />
            <CaseActivitiesCard
              isAuditor={isUserAllowed(ROLES.auditor)}
              rut={rut}
              status={this.state.status?.value}
              activities={this.state.activities || []}
              onClickModalAssignActivity={this.onClickModalAssignActivity}
            />
            {
              this.state.messages && (
                <MailsContents
                  ref={this.setMailRef}
                  messages={this.state.messages}
                  id={this.state._id}
                  sourceMail={this.state.sourceMail}
                  emailArrayToMailsContents={emailArrayToMailsContents}
                  loading={disableCloseCase}
                  onClickModalNewMailsReplays={this.onClickModalNewMailsReplays}
                  toggleModalNewMessage={this.toggleModalNewMessage}
                  NewMessage={this.state.NewMessage}
                  onChangeMessage={this.onChangeMessage}
                  isOpenModalMessageMail={this.state.isOpenModalMessageMail}
                  onSubmit={this.onSubmitNewMailsReplays}
                  removeAttachment={this.removeAttachment}
                />
              )
            }
          </div>
          <div className="col-md-5">
            <CaseSummaryCard
              state={this.state}
              loadingInfoCase={loadingInfoCase}
              createEmail={createEmail}
              onHandleScore={this.handleScore}
              isAuditor={isUserAllowed(ROLES.auditor)}
              showCaseManagement={isOptionAllowed(refinancingAllowedList) && this.state.isRef}
              params={this.props.match?.params || ''}
            />
            {isOptionAllowed([...refinancingAllowedList, ROLES.auditor]) && this.state.isRef && (
              <CaseManagementHistoryCard params={this.props.match?.params || ''} />
            )}
            <CaseCustomerDocumentsTabs
              contact={contact}
              cargandoContract={cargandoContract}
              edad={edad}
              isAuditor={isUserAllowed(ROLES.auditor)}
              onClickContactoEditar={this.onClickContactoEditar}
              onOpenMakeCall={this.openMakeCall}
              signedDoc={this.state.signedDoc}
              onSavePDF={this.handleSavePDF}
              allS3Docs={this.props.allS3Docs}
              getAllS3Documents={this.props.getAllS3Documents}
              caseId={this.state._id}
              docS3Loading={this.props.docS3.loading}
              onSaveDocS3={this.handleSaveDocS3}
              contracts={contracts}
            />
          </div>
        </Row >
      </div >
    );
  }
}

CasoDetalle.propTypes = {
  getMe: PropTypes.func,
  getUsers: PropTypes.func,
  setTitle: PropTypes.func,
  makeCall: PropTypes.func,
  getOrigins: PropTypes.func,
  getRequestGrounds: PropTypes.func,
  getRequestClassifications: PropTypes.func,
  createCase: PropTypes.func,
  updateCase: PropTypes.func,
  deleteCase: PropTypes.func,
  resetState: PropTypes.func,
  getCasesId: PropTypes.func,
  updateCaseMe: PropTypes.func,
  createMyCase: PropTypes.func,
  getCasesIdMe: PropTypes.func,
  getDocumentS3: PropTypes.func,
  postDocumentS3: PropTypes.func,
  getContactByRut: PropTypes.func,
  getContractByRut: PropTypes.func,
  getAllTypesCases: PropTypes.func,
  getSignedDocument: PropTypes.func,
  getAllS3Documents: PropTypes.func,
  resetAllS3Documents: PropTypes.func,
  getAllSubTypesCases: PropTypes.func,
  types: PropTypes.array,
  subtypes: PropTypes.array,
  contracts: PropTypes.array,
  disable: PropTypes.bool,
  disableCreate: PropTypes.bool,
  loadingInfoCase: PropTypes.bool,
  disableCloseCase: PropTypes.bool,
  cargandoContract: PropTypes.bool,
  origins: PropTypes.object,
  currentUser: PropTypes.shape({
    anexo: PropTypes.string,
    denwaPassword: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      rut: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
    goBack: PropTypes.func
  }),
  allS3Docs: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.array
  }),
  score: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.array
  }),
  requestGrounds: PropTypes.array,
  requestGroundsLoading: PropTypes.bool,
  requestClassifications: PropTypes.array,
  requestClassificationsLoading: PropTypes.bool,
  caseInfo: PropTypes.shape({
    isRedec: PropTypes.bool,
    requestGround: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    requestClassification: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  docS3: PropTypes.shape({ loading: PropTypes.bool }),
  caseManagements: PropTypes.shape({ entry: PropTypes.array }),
  contact: PropTypes.shape({
    rut: PropTypes.string,
    rent: PropTypes.number,
    emails: PropTypes.array,
    phones: PropTypes.array,
    birthdate: PropTypes.string,
    addresses: PropTypes.arrayOf(
      PropTypes.shape({
        region: PropTypes.shape({ label: PropTypes.string, }),
        commune: PropTypes.shape({ label: PropTypes.string, }),
      }),
    ),
  })
};

const mapStateToProps = ({ cases, contacts, users, resources, management, score }) => ({
  caseManagements: management.caseManagements,
  origins: resources.origins,
  cargandoContract: contacts.cargandoContract,
  contracts: contacts.contracts,
  contact: contacts.contact,
  update: contacts.update,
  disableCloseCase: cases.disableCloseCase,
  loadingInfoCase: cases.loadingInfoCase,
  disableCreate: cases.disableCreate,
  allS3Docs: cases.allS3Docs,
  caseInfo: cases.caseInfo,
  subtypes: cases.subtypes,
  disable: cases.disable,
  types: cases.types,
  docS3: cases.docS3,
  doc: cases.doc,
  requestGrounds: cases.requestGrounds.data,
  requestGroundsLoading: cases.requestGrounds.loading,
  requestClassifications: cases.requestClassifications.data,
  requestClassificationsLoading: cases.requestClassifications.loading,
  currentUser: users.currentUser,
  users: users.collection,
  score: score.score,
});


const mapDispatchToProps = {
  setTitle: changeTitleAction,
  getAllSubTypesCases,
  getAllTypesCases,
  getCasesIdMe,
  getScoreList,
  getMe,
  getCasesId,
  deleteCase,
  updateCase,
  updateCaseMe,
  createCase,
  getContactByRut,
  createMyCase,
  getUsers,
  makeCall,
  getContractByRut,
  resetState,
  getAllS3Documents,
  getSignedDocument,
  getDocumentS3,
  postDocumentS3,
  resetAllS3Documents,
  getOrigins,
  getRequestGrounds,
  getRequestClassifications,
};
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CasoDetalle);
